export default __webpack_public_path__ + "static/media/user_Rainbow.d6818ed6.svg";